import { MessagingClient } from "./messagingClient";
import type { WebScriptCommandsTypes } from "./webScriptCommands";
import { WebScriptCommands } from "./webScriptCommands";
export const webScriptClient = new MessagingClient<WebScriptCommandsTypes>(WebScriptCommands);
